import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import * as Icons from './../sharedComponents/icons/Icons';

const propTypes = {
    image: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.node,
    sticky: PropTypes.bool,
    textColor: PropTypes.string,
    background: PropTypes.string,
    name: PropTypes.string,
    closedAnnouncement: PropTypes.func
};

export default class Announcement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAnnouncement: false
        };

        this.closeAnnouncement = this.closeAnnouncement.bind(this);
    }

    componentWillMount() {
        // Check if the announcement cookie exists
        if (!Cookies.get(this.props.name)) {
            // Cookie does not exist, show the announcement
            this.setState({
                showAnnouncement: true
            });
        }
    }

    closeAnnouncement() {
        this.setState({
            showAnnouncement: false
        }, () => {
            this.props.closedAnnouncement(this.props.name);
        });
    }

    generatetextColorClass(textColor) {
        switch (textColor) {
            case 'dark':
                return 'rec-announcement-text-dark';
            case 'light':
                return 'rec-announcement-text-light';
            default:
                return '';
        }
    }
    
    generatebackgroundClass(background) {
        switch (background) {
            case 'dark':
                return 'rec-announcement-content-bg-dark';
            case 'light':
                return 'rec-announcement-content-bg-light';
            default:
                return '';
        }
    }

    render() {
        if (!this.state.showAnnouncement) {
            return null;
        }

        let stickyClass = 'rec-announcement-sticky';
        if (!this.props.sticky) {
            stickyClass = '';
        }

        const textColorClass = this.generatetextColorClass(this.props.textColor);
        const backgroundClass = this.generatebackgroundClass(this.props.background);

        return (
            <div className={`rec-announcement ${textColorClass} ${stickyClass}`} style={this.props.image}>
                <button
                    className="rec-button-link"
                    onClick={this.closeAnnouncement}
                    aria-label="Dismiss Announcement"
                    type="button">
                    <Icons.IconClose />
                </button>
                <div className={`rec-announcement-content ${backgroundClass}`}>
                    <div className="rec-announcement-title">{this.props.title}</div>
                    <div className="rec-announcement-description">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

Announcement.propTypes = propTypes;
